<script lang="ts" setup>
import type { SubnavigationTypeFragment } from '~~layers/.nuxt/graphql-operations'

type SubnavigationItem = SubnavigationTypeFragment & {
  Subnavigation?: SubnavigationTypeFragment[]
}

const props = defineProps<{
  items: SubnavigationItem[]
  level: number
  banners?: SubnavigationTypeFragment['Banners']
}>()

// const route = useRoute()
const router = useRouter()

const subs = computed(() => {
  return props.items?.filter(item => item?.Show) || []
})

const showSubmenu = ref<number | null>(null)

function openSubnavigation(index: number) {
  showSubmenu.value = index
}

function closeSubnavigation(index: number) {
  if (showSubmenu.value === index) {
    showSubmenu.value = null
  }
}

function toggleSubnavigation(index: number) {
  if (showSubmenu.value === index) {
    closeSubnavigation(index)
  }
  else {
    openSubnavigation(index)
  }
}

function keypress(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    closeSubnavigation(showSubmenu.value || -1)
  }
}

onMounted(() => {
  document.addEventListener('keydown', keypress)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', keypress)
  closeSubnavigation(showSubmenu.value || -1)
})

router.beforeEach(() => {
  showSubmenu.value = null
})
</script>

<template>
  <ul
    class="recursive"
    :class="[
      `recursive--level-${level}`,

    ]"
  >
    <li
      v-for="(item, index) in subs"
      :key="item"
      class="recursive__item"
      :class="{
        'recursive__item--open': showSubmenu === index,
      }"
    >
      <button
        v-if="item?.Subnavigation?.length"
        type="button"
        class="recursive__link"
        aria-haspopup="true"
        :aria-expanded="showSubmenu === index ? 'true' : 'false'"
        @click="toggleSubnavigation(index)"
      >
        <span>{{ item.Title }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>
      <AppLink
        v-else
        :to="item?.Link"
        class="recursive__link"
      >
        <span>{{ item?.Title }}</span>
      </AppLink>

      <!-- <pre>level {{ level }}</pre> -->
      <!-- <pre>item {{ item }}</pre> -->

      <div
        v-if="item?.Subnavigation?.length"
        class="recursive__panel"
      >
        <div class="recursive__header">
          <button
            type="button"
            class="recursive__back"
            @click="toggleSubnavigation(-1)"
          >
            <NuxtIcon name="icon:arrow" />
            <!-- <span class="recursive__label">{{ $t('Back') }}</span> -->
            <span class="recursive__name">{{ item?.Title }}</span>
          </button>
        </div>

        <LazyNavigationRecursive
          v-if="item?.Subnavigation?.length"
          :key="item"
          :items="item?.Subnavigation"
          :level="level + 1"
          class="recursive__recursive"
        />

        <AppLink
          v-if="item?.AllTitle"
          :to="item?.Link"
          class="subnavigation__title"
        >
          {{ item.AllTitle }}
        </AppLink>

        <div class="subnavigation__banners--recursive">
          <div
            v-for="banner in banners"
            :key="banner"
            class="subnavigation__banner"
          >
            <StrapiBanner
              :banner="banner"
              lazy
            />
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<style>
@import url("~layers/components/Navigation/Recursive.css");
</style>
